module.exports = __webpack_public_path__ + "static/media/points6_1.06d06f24.png";